import { FC } from "react"
import { SchedulesBatchImport } from "../../../../module/schedules/containers/batchImport"

export const SchedulesCollectiveBatchImportPage: FC = () => (
  <SchedulesBatchImport />
)
